// Import PGBA common plugin
import PgbaCommonPlugin from '../common/PgbaCommonPlugin';

import Vue from 'vue';
import Vuex from 'vuex';

// Import component parsing utility
import ComponentParser from '../util/ComponentParser';

// Import bootstrap vue components
import BootstrapVue from 'bootstrap-vue';

// Import custom Header components
import Header from './components/Header.vue';

// Import header resources
import {getStore} from './header-resources';

// Register framework libraries
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(PgbaCommonPlugin);

const store = getStore();

ComponentParser.parse('pgba-header', Header, { store });
